var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.034 11.2923C14.684 11.634 14.484 12.1256 14.534 12.6506C14.609 13.5506 15.434 14.209 16.334 14.209H17.9173V15.2006C17.9173 16.9256 16.509 18.334 14.784 18.334H5.21732C3.49232 18.334 2.08398 16.9256 2.08398 15.2006V9.59233C2.08398 7.86733 3.49232 6.45898 5.21732 6.45898H14.784C16.509 6.45898 17.9173 7.86733 17.9173 9.59233V10.7923H16.234C15.7673 10.7923 15.3423 10.9756 15.034 11.2923Z",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08398 10.3421V6.53379C2.08398 5.54212 2.69232 4.65875 3.61732 4.30875L10.234 1.80875C11.2673 1.41708 12.3757 2.18377 12.3757 3.29211V6.45876",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7997 11.642V13.3587C18.7997 13.817 18.433 14.192 17.9663 14.2086H16.333C15.433 14.2086 14.608 13.5503 14.533 12.6503C14.483 12.1253 14.683 11.6336 15.033 11.292C15.3413 10.9753 15.7663 10.792 16.233 10.792H17.9663C18.433 10.8087 18.7997 11.1836 18.7997 11.642Z",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 10H11.6673",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.9921738584b458d744a65a6024f69d01.svg";
export { ForwardRef as ReactComponent };